import Vue from 'vue';
import { api } from "../../services/Api.js";

export function unc( { state }, payload ){

    
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
  
    return new Promise((resolve)=>{
    // make api call
    api
      .post(school,"unc.php",payload)
      .then( result =>{ 
        resolve(result);
      })
      .catch( error => {
        
        Vue.$toaster.toast("store: add_album: "+error);
      })

    });// promise
    
  }